export class QueryResultsModel {
	// fields
	'hydra:member': any[];
	'hydra:totalItems': number;
	items: any[];
	totalCount: number;
	errorMessage: string;

	constructor(
		_hydra_member: any[] = [],
		_hydra_totalItems = 0,
		_errorMessage = ''
	) {
		this['hydra:member'] = _hydra_member;
		this['hydra:totalItems'] = _hydra_totalItems;
	}
}
